export default __webpack_public_path__ + "static/media/document-instruction.34f0c82d.svg";